
<div class="notifications">
  <div class="ui centered inline loader" :class="{'active': form.waiting}"></div>
  <dropdown v-model="form.model.announcement_read" :placeholder="'すべて'" @change="search()">
    <option value="">すべて</option>
    <option value="false">未読</option>
    <option value="true">既読</option>
  </dropdown>
  <pagination :pager="pager" :callback="search"></pagination>
  <table class="ui striped table">
    <thead>
      <tr>
        <th class="title-column">タイトル</th>
        <th class="date-column">受信日時</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="announcement in announcements" :key="announcement.id">
        <td class="title-column">
          <span v-if="!announcement.read" class="ui teal label">未読</span>
          <span v-else class="ui label">既読</span>
          <a class="clickable" :href="announcement.url" @click="dispatch(announcement)">{{ announcement.title }}</a>
        </td>
        <td class="date-column">{{ announcement.created_at | formatDatetime }}</td>
      </tr>
    </tbody>
  </table>
</div>
